import * as React from "react";
import { motion } from "framer-motion";
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import Typography from "@mui/material/Typography";
import SchoolIcon from "@mui/icons-material/School";

const TimeLine = () => {
  const variants = {
    visible: { opacity: 1, y: 0 },
    hidden: { opacity: 0, y: 50 },
  };

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      variants={variants}
      transition={{ duration: 0.5 }}
    >
      <div className="min-w-[280px] max-w-[450px]">
        <Timeline
          sx={{
            [`& .${timelineItemClasses.root}:before`]: {
              flex: 0,
              padding: 0,
              m: 0,
            },
          }}
        >
          <TimelineItem className="hover:scale-[1.01] transition-all duration-200 ">
            <TimelineSeparator>
              <TimelineConnector />
              <TimelineDot>
                <SchoolIcon />
              </TimelineDot>
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent sx={{ py: "8px", px: 2 }}>
              <Typography variant="h6" component="span" sx={{ fontSize: "16px", fontWeight: "bold" }}>
                Bachelor of Engineering in Computer Science
              </Typography>
              <Typography  sx={{ fontSize: "14px"}}>Pune Institute of Computer Technology, Pune</Typography>
              <Typography sx={{ fontSize: "14px"}}>2022 - Current</Typography>
            </TimelineContent>
          </TimelineItem>
          <TimelineItem className="hover:scale-[1.01] transition-all duration-200 ">
            <TimelineSeparator>
              <TimelineConnector />
              <TimelineDot color="primary">
                <SchoolIcon />
              </TimelineDot>
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent sx={{ py: "8px", px: 2 }}>
              <Typography variant="h6" component="span" sx={{ fontSize: "16px", fontWeight: "bold" }}>
                Higher Secondary Certificate (HSC)
              </Typography>
              <Typography sx={{ fontSize: "14px"}}>Dnantirth International College, Ahmednagar</Typography>
              <Typography sx={{ fontSize: "14px"}}>CET - 99.06% HSC - 88.67%</Typography>
              <Typography sx={{ fontSize: "14px"}}>2020 - 2022</Typography>
            </TimelineContent>
          </TimelineItem>
          <TimelineItem className="hover:scale-[1.01] transition-all duration-200 ">
            <TimelineSeparator>
              <TimelineConnector />
              <TimelineDot color="primary" variant="outlined">
                <SchoolIcon />
              </TimelineDot>
              <TimelineConnector sx={{ bgcolor: "secondary.main" }} />
            </TimelineSeparator>
            <TimelineContent sx={{ py: "8px", px: 2 }}>
              <Typography variant="h6" component="span" sx={{ fontSize: "16px", fontWeight: "bold" }}>
                Secondary School Certificate (SSC)
              </Typography>
              <Typography sx={{ fontSize: "14px"}}>Mahatma Phule Vidyalaya, Bhalwani</Typography>
              <Typography sx={{ fontSize: "14px"}}>SSC - 93%</Typography>
              <Typography sx={{ fontSize: "14px"}}>2015 - 2020</Typography>
            </TimelineContent>
          </TimelineItem>
        </Timeline>
      </div>
    </motion.div>
  );
};

export default TimeLine;
